import React from 'react';
import { array } from 'prop-types';
import useStyles from 'hooks/useStyles';
import Tag from '../Tag';

import styles from './TagList.scss';

function TagList({ list }) {
  useStyles(styles);

  return (
    <div className={styles.root}>
      {list.map(({ id, name }) => (
        <Tag className={styles.item} key={id} text={name} />
      ))}
    </div>
  );
}

TagList.propTypes = {
  list: array.isRequired,
};

export default TagList;
